const routes = [
  {
    path: 'pullup-load',
    name: 'pullup-load',
    component: () => import(/* webpackChunkName: "pullup-load" */ '@/modules/pullup-load/index.vue'),
    children: [
      {
        path: '',
        name: 'pullup-load',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/pullup-load/demo1.vue')
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/pullup-load/demo1.vue')
      },
      {
        path: 'code',
        name: 'code',
        component: () => import(/* webpackChunkName: "code" */ '@/modules/pullup-load/code.vue')
      },
    ]
  },
];

export default routes;